import Backdraft from "backdraft-app/src/backdraft";

import TtsPromptPlayButton from "./views/components/TtsPromptPlayButton";

// TODO: Other legacy Backdraft apps reference Header's app.components object. We can remove this file when we convert shared components to Webpacker.
Backdraft.app("Header", function(app) {
  app.components = app.components || {};
  app.components['TtsPromptPlayButton'] = TtsPromptPlayButton;
});
